const formatToBrCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };
  
  export const currency = {
    formatToBrCurrency,
  };
  